import React from 'react';
import './QuoteCard.css';

const QuoteCard = ({ quote, className = '' }) => {
  if (!quote) return null;

  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div
      className={`quote-card ${className}`}
      style={{
        width: '1080px',
        height: '1350px',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Background - Paper/Ink Wash Texture */}
      <div className="quote-card-bg" />

      {/* Content Container */}
      <div className="quote-card-content">
        {/* Main Quote - English */}
        <div className="quote-main">
          <blockquote className="quote-text">
            "{quote.text}"
          </blockquote>
        </div>

        {/* Chinese Quote */}
        {quote.chinese && (
          <div className="quote-chinese">
            {quote.chinese}
          </div>
        )}

        {/* Author Seal Style */}
        <div className="quote-author-seal">
          <div className="seal-box">
            <span className="seal-text">{quote.author}</span>
          </div>
        </div>

        {/* Source */}
        {quote.source && (
          <div className="quote-source">
            {quote.source}
          </div>
        )}

        {/* Footer */}
        <div className="quote-footer">
          <div className="footer-brand">Wisdom Nexus</div>
          <div className="footer-date">{currentDate}</div>
          <div className="footer-url">wisdomnexus.com</div>
        </div>
      </div>
    </div>
  );
};

export default QuoteCard;
